import axios from 'axios'

const service = axios.create({
  baseURL: '',
  timeout: 15000
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    const openid = localStorage.getItem('openid') || ''
    if (openid) {
      config.headers['OPENID'] = openid
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    console.log('[API Response]', response.config.url, res)
    // 统一处理：code === 0 时返回 res.data，否则返回 res（保留 code 和 msg 供业务判断）
    if (res && typeof res === 'object' && res.code !== undefined) {
      if (res.code === 0) {
        // 如果 data 存在且不是 null，返回 data；否则返回整个 res
        if (res.data !== undefined && res.data !== null) {
          return res.data
        }
        return res
      }
    }
    return res
  },
  error => {
    return Promise.reject(error)
  }
)

// API 接口

// 获取科目分类列表
export const getSubjects = () => service.get('/api/wx/subjectitem')

// 根据父级ID获取子级科目
export const getSubjectByPid = (pid, menuId) =>
  service.get('/api/wx/subjectitem/bypid', { params: { pid, menuId } })

// 获取试卷信息
export const getPaperInfo = (id) =>
  service.get('/api/wx/paper/info', { params: { id } })

// 获取试卷题目
export const getPaperQuestions = (id) =>
  service.get('/api/wx/paper/questions', { params: { id } })

// 获取试卷解析
export const getPaperAnalysis = (id) =>
  service.get('/api/wx/paper/analysis', { params: { id } })

// 获取关联试卷
export const getPaperRelation = (id) =>
  service.get('/api/wx/paper/info/relation', { params: { id } })

// 提交试卷
export const postPaper = (paperId, questions) =>
  service.post('/api/wx/postpaper', { paperId, questions })

// 获取练习统计
export const getPracticeStatistic = () =>
  service.get('/api/wx/mine/practice/statistic')

// 获取最近练习
export const getPracticeLatest = () =>
  service.get('/api/wx/mine/practice/latest')

// 获取我的练习列表
export const getMyPractice = (params) =>
  service.get('/api/wx/mine/practice', { params })

// 获取我的考试列表
export const getMyExam = (params) =>
  service.get('/api/wx/mine/exam', { params })

// 获取我的收藏
export const getMyCollection = (params) =>
  service.get('/api/wx/mine/collection', { params })

// 获取错题列表
export const getWrongQuestions = (params) =>
  service.get('/api/wx/wrong/questions', { params })

// 获取错题分类
export const getWrongQuestionsCat = (params) =>
  service.get('/api/wx/wrong/questions/cat', { params })

// 删除错题
export const deleteWrong = (id, pid) =>
  service.post('/api/wx/wrong/delete', { id, pid })

// 清空错题
export const clearWrong = (pid, paperId) =>
  service.post('/api/wx/wrong/clear', { pid, paperId })

// 按科目搜索题目
export const getSubjectQuestions = (params) =>
  service.get('/api/wx/subject/questions', { params })

// 获取用户认证信息
export const getAuthInfo = () =>
  service.get('/api/wx/authinfo')

// 获取账户信息（用于校验登录状态）
export const getAccountInfo = () =>
  service.get('/api/account/info')

// 身份证登录
export const idcardLogin = (name, idcard) =>
  service.post('/api/account/idcard/login', { name, idcard })

// 获取订单列表
export const getMyOrders = () =>
  service.get('/api/wx/mine/orders')

// 添加/取消收藏
export const toggleCollection = (questionId, collected) =>
  service.post('/api/wx/collection/toggle', { questionId, collected })

export default service
